import { render } from "./contractEdit.vue?vue&type=template&id=70b110c4"
import script from "./contractEdit.vue?vue&type=script&lang=js"
export * from "./contractEdit.vue?vue&type=script&lang=js"

import "./contractEdit.vue?vue&type=style&index=0&id=70b110c4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/createProject/contractEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70b110c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70b110c4', __exports__)) {
    api.reload('70b110c4', __exports__)
  }
  
  module.hot.accept("./contractEdit.vue?vue&type=template&id=70b110c4", () => {
    api.rerender('70b110c4', render)
  })

}


export default __exports__